import AppTagStatus from '@nxsys/components/AppTagStatus';
import { TypedMessages } from '@nxsys/hooks/useTypedIntl';
import { Assignment } from '@nxsys/store/slices/assignment/types';
import { Icons } from '@nxsys/types/icons';
import { formatStatus } from '@nxsys/utils';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

export const getColumns = ({
  messages,
  handleViewDetail,
}: {
  messages: TypedMessages;
  handleViewDetail: (id: string) => void;
}): ColumnsType<Assignment> => {
  return [
    {
      key: 'action',
      title: messages['common.action'],
      fixed: 'left',
      align: 'left',
      render: (record) => (
        <ul className="flex items-center justify-center gap-x-2">
          <li onClick={() => handleViewDetail(record?.id)}>
            <Tooltip title="Edit">
              <span><Icons.IconEdit /></span>
            </Tooltip>
          </li>
          {record?.file && (
            <li onClick={() => window.open(record.file, '_blank')}>
              <Tooltip title="Download">
                <span><Icons.IconDownload /></span>
              </Tooltip>
            </li>
          )}
        </ul>
      ),
      width: 100,
    },
    {
      key: 'status',
      title: messages['assignment.columns.status'],
      align: 'center',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      fixed: 'left',
      render: (record) => {
        const status = record?.status;
        return (
          <span className={`${formatStatus(status)}`}>
            <AppTagStatus className={`tag-popup ${formatStatus(status)}`}>
              {formatStatus(status)}
            </AppTagStatus>
          </span>
        );
      },
      width: 150,
    },
    {
      key: 'assignmentName',
      title: messages['assignment.columns.assignmentName'],
      dataIndex: 'assignmentName',
    },
    {
      key: 'subcontractorName',
      title: messages['assignment.columns.employeeSubcontractor'],
      dataIndex: 'subcontractorRef',
      render: (record) => `${record?.forename ?? ''} ${record?.surname ?? ''}`,
    },
    {
      key: 'agencyName',
      title: messages['assignment.columns.agencyName'],
      dataIndex: 'agencyRef',
      render: (record) => record?.name ?? '',
    },
    {
      key: 'startDate',
      title: messages['assignment.columns.startDate'],
      dataIndex: 'startDate',
      align: 'right',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (record) =>
        record && moment(record) ? moment(record)?.format('DD/MM/YYYY') : '_',
    },
    {
      key: 'endDate',
      title: messages['assignment.columns.endDate'],
      dataIndex: 'endDate',
      align: 'right',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (record) =>
        record && moment(record) ? moment(record)?.format('DD/MM/YYYY') : '_',
    },
    {
      key: 'createdBy',
      title: messages['common.createdBy'],
      dataIndex: 'author',
      render: (value) => {
        if (!value) return '-';
        const name = `${value?.forename ?? ''} ${value?.surname ?? ''}`.trim();
        return name || '-';
      },
    },
    {
      key: 'createdOn',
      title: messages['common.createdOn'],
      dataIndex: 'createdAt',
      align: 'right',
      render: (record) =>
        record && moment(record) ? moment(record)?.format('DD/MM/YYYY') : '-',
    },
  ];
};
